// extracted by mini-css-extract-plugin
export var label = "_jv-0";
export var treatmentCard = "_jv-1";